import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useDispatch, useIntl } from '@grandvisionhq/state';
import { useConfiguratorContext } from '../../../../Context/ConfiguratorContext.js';
import { usePrivateSteppingContext } from '../../../../Context/PrivateSteppingContext.js';
import { toggleFooter } from '../../../../state/actions.js';
import { ExpanderToggle } from './ExpanderToggle.js';

const ExpanderToggleContainer = (props)=>{
    const dispatch = useDispatch();
    const { getLabel  } = useIntl();
    const { isFooterOpen , configuratorId: id  } = useConfiguratorContext();
    const { footerExpanderContent  } = usePrivateSteppingContext();
    const toggleFooter$1 = React.useCallback(()=>{
        dispatch(toggleFooter({
            id
        }));
    }, [
        dispatch,
        id
    ]);
    const label = React.useMemo(()=>getLabel('products.glasses.configurator.footer.toggle')
    , [
        getLabel
    ]);
    // Hide the expander toggle if no expander content was received
    return !footerExpanderContent ? null : /*#__PURE__*/ React.createElement(ExpanderToggle, swcHelpers.extends({}, props, {
        label: label,
        isExpanded: isFooterOpen,
        onToggleClick: toggleFooter$1
    }));
};

export { ExpanderToggleContainer };
//# sourceMappingURL=ExpanderToggleContainer.js.map
